module.exports = __webpack_public_path__ + "static/media/bps-small.a5c42128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bps-small.png
// module id = 502
// module chunks = 0